import { AutocompleteAPI, CheckboxAPI, DateFieldAPI, FieldAPI, FormAPI, InputAPI, LocatorAPI, RadioGroupAPI, SelectableItem, TextAreaAPI, ToastService, WizardAPI, FetchAPI } from '@philips-internal/oswald-ui-components';
import { Placement, ToastLevel, ToastType } from '@philips-internal/oswald-ui-constants';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { Value } from '@philips-internal/oswald-ui-core';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';
import DialogService from '../../../../services/dialog-service';
import { Inject } from '@odinjs/odin';
import { foundationContext } from '@philips-internal/oswald-ui-foundation';

import moment, { Moment } from 'moment';

import { HealthHistoryMedicinesCreateAliases as Alias } from '../../../../codegen';

import BaseController from '../../../BaseController';
import { HealthProfessionalUser } from '../../../../app/authentication';
import { Endpoint } from '../../../../constants/endpoints';
import { WizardSteps } from '../../../../constants/wizards';
import { DateHandleStartOf, DateTypeId, DomainType, HealthHistoryMedicineResponse, SearchType } from '../../health-history-types';
import { MedicinesRadioGroupId, MedicinesRadioGroupValuesId } from '../radio-group-data/radio-group-data-expressions';
import { DEFAULT_DATE_PATTERN, MONTH_YEAR_PATTERN, YEAR_PATTERN, ISO_FULL_DATE_FORMAT } from '../../../../constants/date-utils';
import HealthHistoryCommons from '../../health-history-commons';
import { BooleanUtils } from '../../../../utils/boolean-utils';
import { FoundationUtils } from '../../../../utils/foundation-utils';
import { FunctionName, PEP_281Parameters } from '../../../../utils/parameters';

export default class HealthHistoryMedicinesHandle extends BaseController {

	@Inject(Alias.WIZARD)
	private wizardAPI!: WizardAPI;

	@Inject(Alias.FORM_ONE)
	private formOneAPI!: FormAPI;

	@Inject(Alias.FORM_TWO)
	private formTwoAPI!: FormAPI;

	@Inject(Alias.FORM_THREE)
	private formThreeAPI!: FormAPI;


	@Inject(Alias.AUTOCOMPLETE_INTERVAL)
	private autocompleteIntervalAPI!: AutocompleteAPI;

	@Inject(Alias.AUTOCOMPLETE_PROVENANCE)
	private autocompleteProvenanceAPI!: AutocompleteAPI;

	@Inject(Alias.AUTOCOMPLETE_INTERRUPT_REASON)
	private autocompleteInterruptReasonAPI!: AutocompleteAPI;

	@Inject(Alias.AUTOCOMPLETE_DATE_TYPE)
	private autocompleteDateTypeAPI!: AutocompleteAPI;

	@Inject(Alias.AUTOCOMPLETE_UNITY_MEASURE)
	private autocompleteUnityAPI!: AutocompleteAPI;

	@Inject(Alias.AUTOCOMPLETE_CHANNEL_ADM)
	private autocompleteChannelAdmAPI!: AutocompleteAPI;


	@Inject(Alias.FIELD_UNKNOWN_INFO_MEDICINE)
	private fieldUnknownInfoMedAPI!: FieldAPI;

	@Inject(Alias.FIELD_FIRST_TRIMESTER)
	private fieldFirstTrimesterAPI!: FieldAPI;

	@Inject(Alias.FIELD_SECOND_TRIMESTER)
	private fieldSecondTrimesterAPI!: FieldAPI;

	@Inject(Alias.FIELD_THIRD_TRIMESTER)
	private fieldThirdTrimesterAPI!: FieldAPI;

	@Inject(Alias.FIELD_START_DATE)
	private fieldStartDateAPI!: FieldAPI;

	@Inject(Alias.FIELD_START_MONTH)
	private fieldStartMonthAPI!: FieldAPI;

	@Inject(Alias.FIELD_START_YEAR)
	private fieldStartYearAPI!: FieldAPI;

	@Inject(Alias.FIELD_JUSTIFICATION_FOR_END)
	private fieldJustificationForEndAPI!: FieldAPI;


	@Inject(Alias.INPUT_UNREGISTRED_MEDICINE)
	private inputUnregistredMedicineAPI!: InputAPI;

	@Inject(Alias.INPUT_SCHEDULES)
	private inputSchedulesAPI!: InputAPI;

	@Inject(Alias.INPUT_MEDICINE)
	private inputMedicineAPI!: InputAPI;

	@Inject(Alias.INPUT_START_YEAR)
	private inputStartYearAPI!: InputAPI;

	@Inject(Alias.INPUT_START_MONTH)
	private inputStartMonthAPI!: InputAPI;

	@Inject(Alias.INPUT_QT_DOSE)
	private inputQtDoseAPI!: InputAPI;


	@Inject(Alias.LOCATOR_MEDICINE)
	private locatorMedicineAPI!: LocatorAPI;


	@Inject(Alias.TEXT_AREA_REACTION)
	private textAreaReactionAPI!: TextAreaAPI;


	@Inject(Alias.CHECKBOX_SELF_MEDICATION)
	private checkboxSelfMedAPI!: CheckboxAPI;

	@Inject(Alias.CHECKBOX_UNKNOWN_START)
	private checkboxUnknownStartAPI!: CheckboxAPI;

	@Inject(Alias.CHECKBOX_UNKNOWN_END)
	private checkboxUnknownEndAPI!: CheckboxAPI;

	@Inject(Alias.CHECKBOX_UNKNOWN_LAST_DOSE)
	private checkboxUnknownLastDoseAPI!: CheckboxAPI;

	@Inject(Alias.CHECKBOX_UNKNOWN_INFO_MEDICINE)
	private checkboxUnknownInfoMedicine!: CheckboxAPI;


	@Inject(Alias.DATE_FIELD_START_DATE)
	private dateFieldStartDateAPI!: DateFieldAPI;

	@Inject(Alias.DATE_FIELD_END_DATE)
	private datefieldEndDateAPI!: DateFieldAPI;

	@Inject(Alias.DATE_FIELD_LAST_DATE)
	private datefieldLastDateAPI!: DateFieldAPI;

	@Inject(Alias.FETCH_UNITY_MEASURE)
	private fetchUnityMeasureAPI!: FetchAPI;

	@Inject(Alias.FETCH_CHANNEL_ADM)
	private fetchChannelAdmAPI!: FetchAPI;

	public getPatientInfo(): void {
		const { encounterId } = this.historyService.getCurrentRouteParams();
		HttpService.get(Endpoint.GET_PATIENT_GENDER, {encounterId})
			.then((res) => {
				const data = res.body as Record<string, Value>;
				this.displayPregnancyFields(data?.gender);
			}).catch((err) => err?.body?.errorMessage && this.showToast(err.body.errorMessage, ToastLevel.ERROR));
	}


	private displayPregnancyFields(gender: any): void {
		const genderFemale = 'F';
		HealthHistoryCommons.setVisibleFields([
			this.fieldFirstTrimesterAPI,
			this.fieldSecondTrimesterAPI,
			this.fieldThirdTrimesterAPI], gender && gender === genderFemale);
	}

	public handleJustificationForEnd() {
		const justificationForEnd = FoundationUtils.findModuleParam(FunctionName.PEP_281, PEP_281Parameters.JUSTIFICATION_FOR_END)
		HealthHistoryCommons.setVisibleField(this.fieldJustificationForEndAPI, BooleanUtils.isTrueValue(justificationForEnd?.toString()));
	}

	public initUnityMeasure() {
		HealthHistoryCommons.setEnableField(this.autocompleteUnityAPI, false);
	}
	
	public initAdmChannel() {
		HealthHistoryCommons.setEnableField(this.autocompleteChannelAdmAPI, false);
	}

	public mountRadioGroupValues(radioGroup: RadioGroupAPI): void {
		this.getPainScaleData()
			.then(response => {
				const responseBody = response.body as SelectableItem[];

				radioGroup.setData(responseBody);

				this.setRadioGroupValues(responseBody);
			})
			.catch((error) => error?.body?.errorMessage && this.showToast(error.body.errorMessage, ToastLevel.ERROR))
			.finally(() => this.formOneAPI.setLoading(false));
	}

	private getPainScaleData() {
		const { encounterId, patientId } = this.historyService.getCurrentRouteParams();
		const expressionId = MedicinesRadioGroupId.CONTINUOUS_MEDICATION;

		this.formOneAPI.setLoading(true);
		
		return HttpService.get(Endpoint.GET_PAIN_SCALE_DATA, { patientId, encounterId, expressionId });
	}

	private setRadioGroupValues(responseBody: SelectableItem[]) {
		const type         = 'continuousMedication';
		const defaultValue = MedicinesRadioGroupValuesId.CONFIRMED;
		
		const defaultItemSelected = responseBody.find(item => item.value === defaultValue as unknown as string);
		this.formOneAPI.setData({...this.formOneAPI.getData(), [type]: defaultItemSelected});
		this.formOneAPI.validate();
	}

	public mountWizardSteps() {
		this.wizardAPI.setStepDone(WizardSteps.STEP_THREE, true);
		this.wizardAPI.setStepDone(WizardSteps.STEP_TWO, true);
	}

	public handleStepDone(isStepDone: boolean, step: WizardSteps): void {
		if (isStepDone) {
			this.wizardAPI.setStepDone(step, true);
		}
	}

	public mountDateTypeAfterFetch() {
		this.handleDateTypeVisibility();
	}

	private handleDateTypeVisibility(): void {
		const initialDateType = this.context.get('initialDateType') as Record<string, Value>;
		this.autocompleteDateTypeAPI.setValue(initialDateType);
		this.handleVisibilityDates(initialDateType);
	}

	private handleVisibilityDates(dateType: DomainType | Record<string, Value>): void {
		const isDayMonthYear = dateType?.valueDomain === DateTypeId.DAY_MONTH_YEAR;
		const isMonthYear    = dateType?.valueDomain === DateTypeId.MONTH_YEAR;
		const isYear         = dateType?.valueDomain === DateTypeId.YEAR;
	
		HealthHistoryCommons.setVisibleField(this.fieldStartDateAPI, isDayMonthYear || (!isDayMonthYear && !dateType?.valueDomain));
		HealthHistoryCommons.setVisibleField(this.fieldStartMonthAPI, isMonthYear);
		HealthHistoryCommons.setVisibleField(this.fieldStartYearAPI, isYear);
	}

	public mountUnityMeasureAfterFetch(unitiesMeasure: Record<string, Value>[]) {
		this.autocompleteUnityAPI.setData(unitiesMeasure);
		if (unitiesMeasure && unitiesMeasure.length > 0) {
			this.verifyAndSetFirstAutocomplete(this.autocompleteUnityAPI, unitiesMeasure);
		}
	}

	private verifyAndSetFirstAutocomplete(field: any, data: Record<string, Value>[]) {
		if (data.length == 1) {
			field.setValue(data[0]);
		} else {
			this.setEmptyFieldByType(field);
		}
	}

	public mountChannelAdmAfterFetch(channelsAdm: Record<string, Value>[]) {
		this.autocompleteChannelAdmAPI.setData(channelsAdm);
		if (channelsAdm && channelsAdm.length > 0) {
			this.verifyAndSetFirstAutocomplete(this.autocompleteChannelAdmAPI, channelsAdm);
		}
	}

	public handleDateTypeFields(dateType: DomainType, oldDateType: DomainType | undefined): void {
		const oldValue = oldDateType ? this.getValueByDateType(oldDateType) : '';
	
		this.handleVisibilityDates(dateType);
	
		if (oldValue) {
			this.setOldValueInput(oldValue, dateType);
		}
	}

	private getValueByDateType(dateType: DomainType): Moment | undefined {
		let dateValue;
		switch(dateType.valueDomain) {
			case DateTypeId.YEAR: {
				if (!this.inputStartYearAPI.getValue()) break;
				dateValue = moment(this.inputStartYearAPI.getValue());
				break;
			}
			case DateTypeId.MONTH_YEAR: {
				if (!this.inputStartMonthAPI.getValue()) break;
				dateValue = moment(this.inputStartMonthAPI.getValue() as string);
				break;
			}
			default: {
				if (!this.dateFieldStartDateAPI.getValue()) break;
				dateValue = moment(this.dateFieldStartDateAPI.getValue() as string);
				break;
			}
		}
		return dateValue;
	}

	private setOldValueInput(oldValue : Moment, dateType: DomainType): void  {
		switch(dateType.valueDomain) {
			case DateTypeId.YEAR: {
				this.fieldStartYearAPI.setValue(moment(oldValue).startOf(DateHandleStartOf.START_YEAR).format(YEAR_PATTERN));
				break;
			}
			case DateTypeId.MONTH_YEAR: {
				this.fieldStartMonthAPI.setValue(moment(oldValue).startOf(DateHandleStartOf.START_MONTH).format(MONTH_YEAR_PATTERN));
				break;
			}
			default: {
				this.fieldStartDateAPI.setValue(moment(oldValue).format(DEFAULT_DATE_PATTERN));
				break;
			}
		}
	}

	public handleChangeMedicineLocator(medicine: SearchType | unknown): void {
		const hasMedicine = this.hasMedicine(medicine);
		
		HealthHistoryCommons.setEnableFields([
			this.autocompleteUnityAPI,
			this.autocompleteChannelAdmAPI
		], false);

		if (hasMedicine) {
			const medicineCode = (medicine as SearchType).id;
			this.context.set({ medicineCode });

			this.verifyUnknownInfoMed();
			this.forceFetchUnityAndChannel();
		} else {
			this.context.set({ medicineCode: null });
		}

		this.verifyAndSetUnregisteredMedicine(hasMedicine);
	}

	private hasMedicine(medicine: SearchType | unknown): boolean {
		return medicine && (medicine as SearchType).id > 0 ? true : false;
	}

	private verifyUnknownInfoMed() {
		const checkedUnknown = this.fieldUnknownInfoMedAPI.getData();
		this.autocompleteUnityAPI.setEnabled(!checkedUnknown.unknownInfoMedication);
		this.autocompleteChannelAdmAPI.setEnabled(!checkedUnknown.unknownInfoMedication);
	}

	private forceFetchUnityAndChannel() {
		this.fetchUnityMeasureAPI.forceFetch();
		this.fetchChannelAdmAPI.forceFetch();
	}

	private verifyAndSetUnregisteredMedicine(hasMedicine: boolean) {
		HealthHistoryCommons.setEnableField(this.inputUnregistredMedicineAPI, !hasMedicine && !this.isDeniesMedicine());
	}

	private isDeniesMedicine(): boolean {
		return this.context.get('deniesMedicines') as boolean;
	}


	public changeUnknownChecks(field: Alias, checked: boolean) {
		switch (field) {
			case Alias.CHECKBOX_UNKNOWN_INFO_MEDICINE:
					this.handleUnknownInfo(checked);
				break;
			case Alias.CHECKBOX_UNKNOWN_END:
					this.handleUnknownEnd(checked);
				break;
			case Alias.CHECKBOX_UNKNOWN_LAST_DOSE:
					this.handleUnknownLastDose(checked);
				break;
			case Alias.CHECKBOX_UNKNOWN_START:
					this.handleFieldsDate(checked);
				break;
		}
	}

	private handleUnknownInfo(checked: boolean) {
		this.inputQtDoseAPI.setValue('');
		this.handleDisabledFieldsUnknownInfo(checked);
	}

	private handleDisabledFieldsUnknownInfo(checked: boolean): void {
		const deniesMedicines = this.isDeniesMedicine();
		if (!deniesMedicines) {
			this.inputQtDoseAPI.setEnabled(!checked);
			this.autocompleteUnityAPI.setEnabled(!checked);
			this.autocompleteChannelAdmAPI.setEnabled(!checked);
			this.autocompleteIntervalAPI.setEnabled(!checked);
			return;
		}
	}

	private handleUnknownEnd(checked: boolean) {
		this.datefieldEndDateAPI.setValue('');
		this.datefieldEndDateAPI.setEnabled(!checked);
	}

	private handleUnknownLastDose(checked: boolean) {
		this.datefieldLastDateAPI.setValue('');
		this.datefieldLastDateAPI.setEnabled(!checked);
	}

	private handleFieldsDate(checked: boolean) {
		this.autocompleteDateTypeAPI.setEnabled(!checked);

		const isFieldStartDateVisible   = this.fieldStartDateAPI.isVisible();
		const isFieldStartMonthVisible  = this.fieldStartMonthAPI.isVisible();
		const isFieldStartYearVisible   = this.fieldStartYearAPI.isVisible();

		if (isFieldStartDateVisible) {
			HealthHistoryCommons.setEmptyAndVisible(this.dateFieldStartDateAPI, !checked);
		}
	
		if (isFieldStartMonthVisible) {
			HealthHistoryCommons.setEmptyAndVisible(this.inputStartMonthAPI, !checked);
		}
	
		if (isFieldStartYearVisible) {
			HealthHistoryCommons.setEmptyAndVisible(this.inputStartYearAPI, !checked);
		}
	}

	public handleFieldsMedicineContinuousUse(deniesMedicine: boolean): void {
		const fields = [
			this.locatorMedicineAPI,
			this.inputMedicineAPI,
			this.inputUnregistredMedicineAPI,
			this.inputQtDoseAPI,
			this.autocompleteIntervalAPI,
			this.inputSchedulesAPI,
			this.autocompleteProvenanceAPI,
			this.autocompleteInterruptReasonAPI,
			this.datefieldEndDateAPI,
			this.datefieldLastDateAPI,
			this.textAreaReactionAPI,
			this.checkboxSelfMedAPI,
			this.checkboxUnknownStartAPI,
			this.checkboxUnknownEndAPI,
			this.checkboxUnknownLastDoseAPI,
			this.autocompleteUnityAPI,
			this.autocompleteChannelAdmAPI];

		this.handleFieldsDate(deniesMedicine)
		HealthHistoryCommons.setEnableFields(fields, !deniesMedicine);
		
		if (deniesMedicine) {
			this.handleDeniesEmptyFields();
		} else {
			this.handleDateTypeVisibility();
			this.handleDisabledFieldsUnknownInfo(this.checkboxUnknownInfoMedicine.getValue());
			this.handleChangeMedicineLocator(this.locatorMedicineAPI.getValue())
			this.handleUnregisterMedicine(this.hasUnregisteredMedicine())
		}
	}

	private handleDeniesEmptyFields(): void {
		const emptyData = {} as Record<string, Value>;
		this.context.set({ medicine: emptyData, medicineCode: null })

		const fields = [
			this.autocompleteChannelAdmAPI, 
			this.autocompleteDateTypeAPI, 
			this.autocompleteInterruptReasonAPI, 
			this.autocompleteIntervalAPI, 
			this.autocompleteProvenanceAPI,
			this.locatorMedicineAPI,
			this.inputQtDoseAPI,
			this.inputMedicineAPI,
			this.inputSchedulesAPI,
			this.inputUnregistredMedicineAPI,
			this.datefieldEndDateAPI,
			this.datefieldLastDateAPI,
			this.autocompleteUnityAPI,
			this.textAreaReactionAPI,
			this.checkboxSelfMedAPI,
			this.checkboxUnknownStartAPI,
			this.checkboxUnknownEndAPI,
			this.checkboxUnknownLastDoseAPI];

		this.setEmptyFieldsByType(fields);
	}

	private setEmptyFieldsByType(fields: any[]) {
		fields.forEach(field => this.setEmptyFieldByType(field));
	}

	private setEmptyFieldByType(field: any) {
		if(this.isTypeField(field, AutocompleteAPI)) {
			field.setValue(undefined);
		}
		if(this.isTypeField(field, LocatorAPI)) {
			const emptyData = {} as Record<string, Value>;
			field.setValue(emptyData);
		}
		if(this.isTypeField(field, InputAPI) || this.isTypeField(field, DateFieldAPI) || this.isTypeField(field, TextAreaAPI)) {
			field.setValue('');
		}
		if(this.isTypeField(field, CheckboxAPI)) {
			field.setValue(false);
		}
	}

	private isTypeField(field: any, type: any): boolean {
		return field instanceof type;
	}

	private hasUnregisteredMedicine(): boolean {
		return this.inputUnregistredMedicineAPI.getValue() !== '';
	}

	public handleUnregisterMedicine(check: boolean): void {
		if (!this.isDeniesMedicine() && !this.hasMedicine(this.locatorMedicineAPI.getValue())) {
			this.locatorMedicineAPI.setEnabled(!check);
			this.inputMedicineAPI.setEnabled(!check);
			this.autocompleteUnityAPI.setEnabled(check);
			this.autocompleteChannelAdmAPI.setEnabled(true);
		}
	}

	public handleBlurUnregisterMedicine(): void {
		const unregisteredMedicineValue = this.inputUnregistredMedicineAPI.getValue();
		if (unregisteredMedicineValue) {
			this.context.set({medicineDescription: unregisteredMedicineValue});
			this.forceFetchUnityAndChannel();
		} else {
			this.context.set({medicineDescription: null});
		}
	}

	public prepareSubmit() {
		const { encounterId, patientId } = this.historyService.getCurrentRouteParams();
		const user                       = foundationContext.getUser() as unknown as HealthProfessionalUser;
		const formDataOne                = this.formOneAPI.getRecord();
		const formDataTwo                = this.formTwoAPI.getRecord();
		const formDataThree              = this.formThreeAPI.getRecord();
		const isFieldStartDateVisible    = this.fieldStartDateAPI.isVisible();
		const isFieldStartMonthVisible   = this.fieldStartMonthAPI.isVisible();
		const isFieldStartYearVisible    = this.fieldStartYearAPI.isVisible();

		const body = {
			administrationChannel: (formDataTwo.administrationChannel as DomainType)?.valueDomain,
			alertDescription: BooleanUtils.isPositiveValue(formDataOne.alert as boolean),
			beginningDateCode: (formDataThree.beginningDate as DomainType)?.valueDomain,
			continuousMedication: (formDataOne.continuousMedication as SelectableItem)?.key,
			dateLastDose: (this.getFormatDateSubmit(formDataThree.dateLastDose)),
			endDate: (this.getFormatDateSubmit(formDataThree.dateEnd)),
			firstTrimester: BooleanUtils.isPositiveValue(formDataThree.firstTrimester as boolean),
			interruptReasonCode: (formDataTwo.interruptReason as DomainType)?.valueDomain,
			intervalCode: (formDataTwo.interval as DomainType)?.valueDomain,
			justificationForEnd: (formDataThree.justificationForEnd as DomainType)?.valueDomain,
			medicationDescriptionCode: (formDataOne.medicationDescription as SearchType)?.id,
			numberService: parseInt(encounterId as unknown as string),
			observation: formDataThree.observation,
			physicalPerson: patientId,
			professionalCode: user.physicalPersonId,
			provenanceCode: (formDataTwo.provenance as DomainType)?.valueDomain,
			qtDose: formDataOne.qtDose as number,
			reaction: formDataThree.reaction,
			schedules: formDataTwo.schedules,
			secondTrimester: BooleanUtils.isPositiveValue(formDataThree.secondTrimester as boolean),
			securityLevelCode: (formDataTwo.securityLevel as SearchType)?.id,
			selfMedication: BooleanUtils.isPositiveValue(formDataThree.selfMedication as boolean),
			startDate: (isFieldStartDateVisible ? this.getFormatDateSubmit(formDataThree.dateStart) : undefined),
			startMonth: (isFieldStartMonthVisible && formDataThree.startMonth) ? moment(String(formDataThree.startMonth)).startOf('month').utc().format(ISO_FULL_DATE_FORMAT) : undefined,
			startYear: (isFieldStartYearVisible && formDataThree.startYear) ? HealthHistoryCommons.getOnlyYear(formDataThree.startYear) : undefined,
			thirdTrimester: BooleanUtils.isPositiveValue(formDataThree.thirdTrimester as boolean),
			unityMeasurementCode: (formDataTwo.unityMeasurement as DomainType)?.valueDomain,
			unknownEnd: BooleanUtils.isPositiveValue(formDataThree.unknownEnd as boolean),
			unknownInfoMedication: BooleanUtils.isPositiveValue(formDataOne.unknownInfoMedication as boolean),
			unknownLastDose: BooleanUtils.isPositiveValue(formDataThree.unknownLastDose as boolean),
			unknownStart: BooleanUtils.isPositiveValue(formDataThree.unknownStart as boolean),
			unregisteredMedication: formDataOne.unregisteredMedication,
		} as Record<string, Value>;

		this.submitMedicineInUse(body);
	}

	private getFormatDateSubmit(value: any) {
		return this.getFormatDate(value, ISO_FULL_DATE_FORMAT);
	}

	private getFormatDate(value: any, pattern: string) {
		return value ? moment(value).utc().format(pattern) : undefined;
	}

	private submitMedicineInUse(body: Record<string, Value>): void {
		this.handleLoading(true);
	
		HttpService.post(Endpoint.POST_HEALTH_HISTORY_MEDICINE, undefined, {body})
			.then((res) => {
				const { idHealthHistory } = res.body as HealthHistoryMedicineResponse;
				this.showModalSubmit(idHealthHistory as number);
			}).catch((err) => {
				err?.body && this.showToast(err?.body, ToastLevel.ERROR);
			}).finally(() => {
				this.handleLoading(false);
			})
	}

	private showModalSubmit(idHealthHistory: number): void {
		DialogService.open({
			descriptionDialog: 'patient-evolution.release-title-evolution',
			onClickCancel: () => { this.goBack() },
			onClickOk: () => { this.handleReleaseMedicine(idHealthHistory) },
			titleDialog: 'patient-evolution.release-evolution',
			titleOnCancel: 'patient-evolution.release-cancel-evolution',
			titleOnOk: 'patient-evolution.release-submit-evolution',
		})
	}

	private handleReleaseMedicine(idHealthHistory: number): void {
		this.handleLoading(true);
		HttpService.put(Endpoint.RELEASE_HEALTH_HISTORY_MEDICINE, { sequenceNumberMedicine: idHealthHistory })
			.then(() => {
				applicationContext.popNavigationItem();
			}).catch((err) => {
				err?.body && this.showToast(err?.body, ToastLevel.ERROR);
			}).finally(() => {
				this.handleLoading(false);
		})
	}

	private handleLoading(visible: boolean) {
		this.formOneAPI.setLoading(visible);
		this.formTwoAPI.setLoading(visible);
		this.formThreeAPI.setLoading(visible);
	}

	private showToast(message: string, level: ToastLevel): void {
		ToastService.open({
			dismissible: true,
			highlight: false,
			id: 'health-history-medicines-create',
			level,
			message,
			placement: Placement.BOTTOM,
			showIcon: true,
			timeout: 5000,
			type: ToastType.BANNER,
		})
	}

	private goBack(): void {
		applicationContext.popNavigationItem();
		applicationContext.popNavigationItem();
	}
}